export enum LeadCreditStatusEnum {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
}
export enum ApprovedRejectCreditStatusEnum {
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
}
